/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ModuleService {
    /**
     * Store the selected module from navigation.
     */
    public selectedModule: Subject<string> = new Subject<string>();
}
